<script lang="ts" setup>
import FilterTable from "@/components/Common/Table/FilterTable.vue";
import { ref } from "vue";
import type { Header } from "vue3-easy-data-table";
import EasyDataTable from "vue3-easy-data-table";
import "vue3-easy-data-table/dist/style.css";
import Swal from "sweetalert2";
import router from "@/router";
import BaseLoading from "@/components/Common/BaseLoading.vue";
import { usePositionStore } from "@/stores/master/position";
import { toast } from "vue-sonner";
import { hasAccess } from "@/utils/helper";

const linkAdd = {
  text: "Add Position",
  url: "/master/position/create",
};

const headers: Header[] = [
  { text: "CODE", value: "code" },
  { text: "POSITION", value: "name" },
  { text: "ACTIONS", value: "action" },
];

const page = ref<number>(1);
const limit = ref<number>(10);
const totalItems = ref<number>(0);
const listPosition = ref<any>([]);
const positionStore = usePositionStore();
const isLoading = ref(false);

const loadDataPosition = async (query = "") => {
  isLoading.value = true;
  const { success, message } = await positionStore.dispatchGetPositions(
    page.value,
    limit.value,
    query
  );
  if (success) {
    listPosition.value = await positionStore.positions.items;
    page.value = await positionStore.positions.page;
    limit.value = await positionStore.positions.pageSize;
    totalItems.value = await positionStore.positions.total;
  }
  isLoading.value = false;
};

const handleServerOptionsUpdate = (options: {
  page: number;
  rowsPerPage: number;
}) => {
  page.value = options.page;
  limit.value = options.rowsPerPage;
  loadDataPosition();
};

const handleEdit = (role: any) => {
  router.push("/master/position/" + role);
};

const handleDelete = async (position: any) => {
  const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      cancelButton: "btn btn-danger",
      confirmButton: "btn btn-success",
    },
    buttonsStyling: false,
  });
  swalWithBootstrapButtons
    .fire({
      title: `Are you sure want to delete data ${position.name} ?`,
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      reverseButtons: true,
    })
    .then(async (result) => {
      if (result.isConfirmed) {
        const { success, message } = await positionStore.dispatchDelete(
          position.id
        );
        if (success) {
          swalWithBootstrapButtons.fire({
            title: "Deleted!",
            text: "Your file has been deleted.",
            icon: "success",
          });
          loadDataPosition();
        } else {
          toast.error(message);
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        swalWithBootstrapButtons.fire({
          title: "Cancelled",
          text: "Your action has been aborted",
          icon: "error",
        });
      }
    });
};

loadDataPosition();
</script>
<template>
  <div class="card bg-white border-0 rounded-3 mb-4">
    <div class="card-body p-4">
      <div
        class="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-4"
      >
        <h3 class="mb-0">List Data Position</h3>
      </div>
      <FilterTable :link="linkAdd" @searchByQuery="loadDataPosition" />
      <div class="table-content">
        <BaseLoading v-if="isLoading" />
        <EasyDataTable
          :headers="headers"
          :items="listPosition"
          v-if="!isLoading"
          show-index
          :server-options="{
            page: page,
            rowsPerPage: limit,
          }"
          :server-items-length="totalItems"
          @update:server-options="handleServerOptionsUpdate"
          buttons-pagination
        >
          <template #item-action="props">
            <div class="d-flex gap-2">
              <button
                v-if="hasAccess('job-update')"
                class="btn btn-info btn-sm text-white"
                @click="handleEdit(props.id)"
              >
                Edit
              </button>
              <button
                v-if="hasAccess('job-delete')"
                class="btn btn-danger btn-sm"
                @click="handleDelete(props)"
              >
                Delete
              </button>
            </div>
          </template>
        </EasyDataTable>
      </div>
    </div>
  </div>
</template>
